import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import MiniAppService from "../../services/mini-app-service/MiniAppService";
import { AgGridReact } from "ag-grid-react/lib/agGridReact";
import StatusFilterInput from "./inputs/StatusFilterInput";
import TargetFilterInput from "./inputs/TargetFitlerInput";
import { Row, Card, CardHeader } from "shards-react";
import { getGridOptions } from "./options/GridOptions";
import SearchbarInput from "./inputs/SearchbarInput";
import AuthService from "../../services/auth-service/AuthService";
import "./mini-app-list.css";
import "./loader/loading.css";
import { useNavigate } from "react-router-dom";

const MiniAppListScreen = () => {
    const [gridApi, setGridApi] = useState(null);
    const [columnDefs, setColumnDefs] = useState([]);
    const [, setGridColumnApi] = useState(null);
    const [miniApps, setMiniApps] = useState([]);
    const [targets, setTargets] = useState([]);
    const [isSearchDisabled, setIsSearchDisabled] = useState(true);
    const [fullMiniAppsList, setFullMiniAppsList] = useState();
    const [currentSearch, setCurrentSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        navigate(`/applications/${currentPage}`);
    }, [currentPage]);

    useEffect(() => {
        const formatedSearchAsAQuery = formatSearchValueAsAQuery(currentSearch);
        navigate({ search: currentSearch ? formatedSearchAsAQuery : "" });
    }, [currentSearch]);

    const formatSearchValueAsAQuery = value => {
        const hasQueryText = value?.includes("?search=");
        const mountedSearchQuery = hasQueryText ? value : `?search=${value}`;
        return mountedSearchQuery;
    };

    const onGridReady = async params => {
        if (AuthService.isFirstLogin()) navigate("/reset_password");

        params.api.showLoadingOverlay();
        const miniAppsRes = await MiniAppService.findMiniApps();
        const resTargets = await MiniAppService.getTargets();
        const gridOptions = getGridOptions();

        setTargets(resTargets);
        setColumnDefs(gridOptions);
        setMiniApps(miniAppsRes);
        setFullMiniAppsList(miniAppsRes);
        params.api.hideOverlay();
        setGridApi(params.api);
        setGridColumnApi(params.columnApi);

        if (miniAppsRes.length === 0) {
            params.api.showNoRowsOverlay();
        }

        if (miniAppsRes.length > 0) {
            setIsSearchDisabled(false);
        }
    };

    const onFilterTextChanged = search => {
        setCurrentSearch(search);
        gridApi?.setQuickFilter(search);

        if (gridApi.getDisplayedRowCount() === 0) {
            gridApi.showNoRowsOverlay();
        } else {
            gridApi.hideOverlay();
        }
    };

    const onTargetChanged = newValue => {
        targetOption = newValue;
        const selectedTargetId = targets?.find(
            _target => _target?.name === newValue
        )?.id;

        if (targetOption === "default") {
            setMiniApps(fullMiniAppsList);
        } else {
            const filteredMiniapps = fullMiniAppsList?.filter(
                miniapp => miniapp.applicationId === selectedTargetId
            );
            setMiniApps(filteredMiniapps);
        }

        gridApi.onFilterChanged();
    };

    const onPaginationChanged = params => {
        const pageFromPagination = params.api.paginationGetCurrentPage() + 1;
        setCurrentPage(pageFromPagination);
    };

    const doesExternalFilterPass = node => {
        const target = targets.find(target => target.name === node.data.target);
        return !!target;
    };

    const settings = {
        gridOptions: {
            localeText: {
                page: "Página",
                to: "até",
                of: "de"
            }
        },
        onGridReady,
        rowData: miniApps,
        columnDefs,
        pagination: true,
        paginationPageSize: 15,
        rowHeight: 50,
        frameworkComponents: {
            statusFilter: StatusFilterInput
        },
        onPaginationChanged,
        doesExternalFilterPass,
        overlayLoadingTemplate: `
            <div class="loading--container">
                <div class="lds-dual-ring"></div>
                <h1 class="loading--text">Carregando...</h1>
            </div>
        `,
        overlayNoRowsTemplate:
            '<i style="font-size: 18px" >Nenhum Eitri-App foi retornado</i>'
    };

    const externalFilterSettings = { targets, onTargetChanged };
    const cardStyle = { height: "100vh", width: "100%", marginBottom: "20px" };

    return (
        <React.Fragment>
            <Row>
                <SearchbarInput
                    onFilterTextChange={onFilterTextChanged}
                    disabled={isSearchDisabled}
                />
                <TargetFilterInput {...externalFilterSettings} />
            </Row>
            <Card style={cardStyle} className="ag-theme-material">
                <CardHeader className="border-bottom">
                    Seus Eitri-apps
                </CardHeader>
                <AgGridReact {...settings} />
            </Card>
        </React.Fragment>
    );
};

var targetOption = "default";

MiniAppListScreen.propTypes = {
    match: PropTypes.object,
    location: PropTypes.object,
    page: PropTypes.string,
    miniApps: PropTypes.arrayOf(Object),
    filterChangedCallback: PropTypes.func,
    isFetching: PropTypes.bool,
    history: PropTypes.any
};

export default MiniAppListScreen;
